package one.healthium.life.di

import org.koin.dsl.module

internal actual fun composeAppPlatformModule() = module {
}